import * as React from "react";
import { useState } from "react";
import {
  Typography,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { priceFormat } from "src/common/UtilFunctions";
import { ShippingMethodEnum, CfaMethodEnum } from "src/common/enum";

export const TotalsTable = (props) => {
  const { record, currency, ...rest } = props;

  let cfaMethod = record.cfa;
  let cfaMethodEnum = CfaMethodEnum.find((method) => method.id === cfaMethod?.type);
  let shippingMethod = record.shipping_method;
  let shippingMethodEnum = ShippingMethodEnum.find((method) => method.id === shippingMethod?.type);
  let discounts = record.discounts;

  return (
    <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
        <Table size="small">
            <TableBody>
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px"}}>Sub Total</Typography>
                    </TableCell>
                    <TableCell>
                        {priceFormat(record.sub_total, currency)}
                    </TableCell>
                </TableRow>
                { cfaMethod &&
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px"}}>CFA Shipping ({cfaMethodEnum?.name})</Typography>
                    </TableCell>
                    <TableCell>
                        {priceFormat(record.cfa_shipping_amount, currency)}
                    </TableCell>
                </TableRow>
                }
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px"}}>Shipping & Handling ({shippingMethodEnum?.name})</Typography>
                    </TableCell>
                    <TableCell>
                        {priceFormat(record.shipping_amount, currency)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        {discounts.length > 0 ?
                            <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px"}}>
                                Discount ({discounts.map((discount) => `${discount?.promotion?.name} #${discount?.promotion?.code}`).join(', ')})
                            </Typography>
                        :
                            <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px"}}>Discount</Typography>
                        }
                    </TableCell>
                    <TableCell>
                        -{priceFormat(record.discount_amount, currency)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px"}}>Sales Tax</Typography>
                    </TableCell>
                    <TableCell>
                        {priceFormat(record.tax_amount, currency)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px", fontWeight: 600}}>Order Total</Typography>
                    </TableCell>
                    <TableCell sx={{fontWeight: 600}}>
                        {priceFormat(record.total, currency)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px", fontWeight: 600}}>Order Total Paid</Typography>
                    </TableCell>
                    <TableCell sx={{fontWeight: 600}}>
                        {priceFormat(record.total_paid, currency)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography component="span" sx={{lineHeight: "32px", fontSize: "14px", fontWeight: 600}}>Order Total Due</Typography>
                    </TableCell>
                    <TableCell sx={{fontWeight: 600}}>
                        {priceFormat(record.total_due, currency)}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </TableContainer>
  );
}
